(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initAllHibaBuySelectors() {
    var boxes = document.querySelectorAll('[data-hiba-fabric-box]');

    boxes.forEach(function (box) {
      initHibaBuySelector(box);
    });
  }

  function hp(k, d) { var P = window.HIBA_PROPS || {}; return P[k] || d; }

  function initHibaBuySelector(box) {
    if (!box || box.dataset.hibaBuySelectorReady === 'true') return;

    var form =
      box.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    var unitSize = parseFloat(box.dataset.unitSize || '0.5');
    var retailMeterLimit = parseFloat(box.dataset.retailMeterLimit || '60');

    var meterVariantId = box.dataset.meterVariantId || '';
    var swatchVariantId = box.dataset.swatchVariantId || '';

    var modeButtons = box.querySelectorAll('[data-hiba-mode]');
    var swatchButton = box.querySelector('[data-hiba-mode="swatch"]');

    var qtyArea = box.querySelector('[data-hiba-qty-area]');
    var wholesaleArea = box.querySelector('[data-hiba-wholesale-area]');

    var qtyLabel = box.querySelector('[data-hiba-qty-label]');
    var minimumNote = box.querySelector('[data-hiba-minimum-note]');
    var displayQty = box.querySelector('[data-hiba-display-qty]');
    var unitLabel = box.querySelector('[data-hiba-unit]');
    var total = box.querySelector('[data-hiba-total]');

    var meterWarning = box.querySelector('[data-hiba-meter-warning]');
    var meterWarningText = box.querySelector('[data-hiba-meter-warning-text]');
    var goWholesaleButton = box.querySelector('[data-hiba-go-wholesale]');

    var minus = box.querySelector('[data-hiba-minus]');
    var plus = box.querySelector('[data-hiba-plus]');

    var wholesaleMeters = box.querySelector('[data-hiba-wholesale-meters]');
    var wholesaleConversion = box.querySelector('[data-hiba-wholesale-conversion]');
    var wholesaleSubmit = box.querySelector('[data-hiba-wholesale-submit]');
    var whatsapp = box.querySelector('[data-hiba-whatsapp]');

    if (
      !modeButtons.length ||
      !qtyArea ||
      !wholesaleArea ||
      !displayQty ||
      !total ||
      !minus ||
      !plus
    ) {
      return;
    }

    box.dataset.hibaBuySelectorReady = 'true';

    function parseCents(value) {
      var clean = String(value || '0').replace(/[^\d.-]/g, '');
      var number = Number(clean);
      return Number.isFinite(number) ? Math.round(number) : 0;
    }

    var meterPrice = parseCents(box.dataset.meterPrice);
    var swatchPrice = parseCents(box.dataset.swatchPrice);

    var currencyCode = box.dataset.currencyCode || 'USD';
    var productTitle = box.dataset.productTitle || document.title;
    var productUrl = box.dataset.productUrl || window.location.href;
    var whatsappNumber = box.dataset.whatsapp || '';
    var email = box.dataset.email || '';

    var mode = 'meter';
    var pendingWholesaleMeters = null;

    function money(cents) {
      var safeCents = Number.isFinite(Number(cents)) ? Number(cents) : 0;

      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          currencyDisplay: 'narrowSymbol'
        }).format(safeCents / 100);
      } catch (error) {
        return (safeCents / 100).toFixed(2);
      }
    }

    function formatMeters(value) {
      var number = Number(value);
      if (!Number.isFinite(number)) return '';

      return String(Number(number.toFixed(2)))
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1');
    }

    function normalizeUp(value, min, step) {
      var number = Number(value);

      if (!Number.isFinite(number)) number = min;
      if (number < min) number = min;

      var rounded = Math.ceil((number - 0.0000001) / step) * step;
      return Number(rounded.toFixed(2));
    }

    function getIdInput() {
      return form.querySelector('[name="id"]');
    }

    function setVariant(id) {
      var idInput = getIdInput();
      if (!idInput || !id) return;

      idInput.value = id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function setQuantity(qty) {
      var qtyInputs = form.querySelectorAll('[name="quantity"]');

      if (!qtyInputs.length) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
        qtyInputs = form.querySelectorAll('[name="quantity"]');
      }

      qtyInputs.forEach(function (input) {
        input.value = qty;
      });
    }

    function setProperty(name, value) {
      var input = form.querySelector('input[name="properties[' + name + ']"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }

      input.value = value;
    }

    function removeProperty(name) {
      var input = form.querySelector('input[name="properties[' + name + ']"]');
      if (input) input.remove();
    }

    function clearFabricProperties() {
      removeProperty('_hiba_type');
      removeProperty('Fabric quantity');
      removeProperty('Total fabric length');
      removeProperty(hp('total_length', 'Total fabric length'));
      removeProperty('Sold as');
      removeProperty('Checkout note');
      removeProperty('Order type');
      removeProperty(hp('order_type', 'Order type'));
      removeProperty('_hiba_unit_size');
    }

    function getAddButtons() {
      return form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]');
    }

    function setAddToCartVisible(visible) {
      var buttons = getAddButtons();

      buttons.forEach(function (button) {
        button.style.display = visible ? '' : 'none';
      });

      var paymentButton = form.querySelector('.shopify-payment-button');

      if (paymentButton) {
        paymentButton.style.display = 'none';
      }
    }

    function setAddToCartText(text) {
      function updateButton() {
        var buttons = getAddButtons();

        buttons.forEach(function (button) {
          if (button.tagName.toLowerCase() === 'input') {
            button.value = text;
          } else {
            button.textContent = text;
          }
        });
      }

      updateButton();
      window.setTimeout(updateButton, 100);
      window.setTimeout(updateButton, 300);
    }

    function showMeterWarning(meters) {
      pendingWholesaleMeters = meters;

      if (meterWarningText) {
        meterWarningText.textContent =
          formatMeters(meters) +
          ' m is above the retail meter limit of ' +
          formatMeters(retailMeterLimit) +
          ' m. Please request a wholesale quote for this quantity.';
      }

      if (meterWarning) {
        meterWarning.hidden = false;
      }

      setAddToCartVisible(false);
    }

    function hideMeterWarning() {
      pendingWholesaleMeters = null;

      if (meterWarning) {
        meterWarning.hidden = true;
      }

      if (mode !== 'wholesale') {
        setAddToCartVisible(true);
      }
    }

    function goWholesaleWithMeters(meters) {
      mode = 'wholesale';

      modeButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.hibaMode === 'wholesale');
      });

      if (wholesaleMeters) {
        wholesaleMeters.value = formatMeters(meters);
      }

      updateWholesale();

      window.setTimeout(function () {
        if (wholesaleMeters) {
          wholesaleMeters.focus();
        }
      }, 80);
    }

    function updateMeter() {
      setVariant(meterVariantId);

      displayQty.min = unitSize;
      displayQty.step = unitSize;

      var rawValue = String(displayQty.value || '').replace(',', '.');
      var meters = normalizeUp(rawValue, unitSize, unitSize);

      displayQty.value = formatMeters(meters);

      if (qtyLabel) qtyLabel.textContent = hp('length_label', 'Length:');
      if (minimumNote) minimumNote.hidden = false;
      if (unitLabel) unitLabel.textContent = 'm';

      var yards = meters * 1.09361;

      if (retailMeterLimit > 0 && meters > retailMeterLimit) {
        total.textContent = formatMeters(meters) + ' m ≈ ' + yards.toFixed(2) + ' yd';
        clearFabricProperties();
        showMeterWarning(meters);
        return;
      }

      hideMeterWarning();

      var cartUnits = Math.round(meters / unitSize);
      var totalPrice = cartUnits * meterPrice;

      setQuantity(cartUnits);

      removeProperty('Fabric quantity');
      removeProperty('Sold as');
      removeProperty('Checkout note');
      removeProperty('Order type');
      removeProperty(hp('order_type', 'Order type'));

      setProperty('_hiba_type', 'meter');
      setProperty('_hiba_unit_size', String(unitSize));
      setProperty(hp('total_length', 'Total fabric length'), formatMeters(meters) + ' m');

      total.textContent = formatMeters(meters) + ' m ≈ ' + yards.toFixed(2) + ' yd';
      setAddToCartText(hp('add_to_cart', 'ADD TO CART') + ' • ' + money(totalPrice));
    }

    function updateSwatch() {
      hideMeterWarning();

      if (!swatchVariantId) {
        total.textContent = hp('swatch_na', 'Swatch is not available for this product');
        setAddToCartVisible(false);
        return;
      }

      setVariant(swatchVariantId);

      displayQty.min = 1;
      displayQty.step = 1;

      var rawValue = String(displayQty.value || '').replace(',', '.');
      var swatches = normalizeUp(rawValue, 1, 1);

      displayQty.value = String(swatches);

      var totalPrice = swatches * swatchPrice;

      if (qtyLabel) qtyLabel.textContent = hp('swatch_qty', 'Swatch quantity');
      if (minimumNote) minimumNote.hidden = true;
      if (unitLabel) unitLabel.textContent = '';

      setQuantity(swatches);

      removeProperty('Fabric quantity');
      removeProperty('Total fabric length');
      removeProperty(hp('total_length', 'Total fabric length'));
      removeProperty('Sold as');
      removeProperty('Checkout note');

      setProperty('_hiba_type', 'swatch');
      setProperty('_hiba_unit_size', '1');
      setProperty(hp('order_type', 'Order type'), swatches + ' ' + (swatches === 1 ? hp('swatch_one', 'swatch') : hp('swatch_many', 'swatches')));

      total.textContent = swatches + (swatches === 1 ? ' swatch selected' : ' swatches selected');
      setAddToCartText(hp('add_to_cart', 'ADD TO CART') + ' • ' + money(totalPrice));
    }

    function updateWholesale() {
      qtyArea.hidden = true;
      wholesaleArea.hidden = false;

      setAddToCartVisible(false);
      clearFabricProperties();

      if (!wholesaleMeters || !wholesaleConversion) return;

      var meters = parseFloat(String(wholesaleMeters.value || '').replace(',', '.'));

      if (Number.isFinite(meters) && meters > 0) {
        var yards = meters * 1.09361;
        wholesaleConversion.textContent = formatMeters(meters) + ' m ≈ ' + yards.toFixed(2) + ' yd';
      } else {
        wholesaleConversion.textContent = hp('yard_hint', 'Enter meters to see yard conversion');
      }
    }

    function update() {
      if (mode === 'wholesale') {
        updateWholesale();
        return;
      }

      qtyArea.hidden = false;
      wholesaleArea.hidden = true;

      if (mode === 'meter') {
        updateMeter();
        return;
      }

      if (mode === 'swatch') {
        updateSwatch();
      }
    }

    function previewWhileTyping() {
      var raw = String(displayQty.value || '').trim().replace(',', '.');

      if (raw === '' || raw === '.' || raw === ',') {
        hideMeterWarning();
        total.textContent = mode === 'swatch' ? 'Enter swatch quantity' : 'Enter length in meters';
        return;
      }

      var typedValue = parseFloat(raw);

      if (!Number.isFinite(typedValue)) {
        hideMeterWarning();
        total.textContent = mode === 'swatch' ? 'Enter swatch quantity' : 'Enter length in meters';
        return;
      }

      if (mode === 'meter') {
        var roundedMeters = normalizeUp(typedValue, unitSize, unitSize);
        var yards = roundedMeters * 1.09361;

        if (retailMeterLimit > 0 && roundedMeters > retailMeterLimit) {
          if (Math.abs(roundedMeters - typedValue) > 0.0001) {
            total.textContent =
              'Will round to ' +
              formatMeters(roundedMeters) +
              ' m ≈ ' +
              yards.toFixed(2) +
              ' yd';
          } else {
            total.textContent = formatMeters(roundedMeters) + ' m ≈ ' + yards.toFixed(2) + ' yd';
          }

          showMeterWarning(roundedMeters);
          return;
        }

        hideMeterWarning();

        if (roundedMeters !== typedValue) {
          total.textContent =
            'Will round to ' +
            formatMeters(roundedMeters) +
            ' m ≈ ' +
            yards.toFixed(2) +
            ' yd';
        } else {
          total.textContent = formatMeters(roundedMeters) + ' m ≈ ' + yards.toFixed(2) + ' yd';
        }

        return;
      }

      if (mode === 'swatch') {
        var roundedSwatches = normalizeUp(typedValue, 1, 1);

        if (roundedSwatches !== typedValue) {
          total.textContent =
            'Will round to ' +
            roundedSwatches +
            (roundedSwatches === 1 ? ' swatch' : ' swatches');
        } else {
          total.textContent =
            roundedSwatches +
            (roundedSwatches === 1 ? ' swatch selected' : ' swatches selected');
        }
      }
    }

    function commitQtyInput(redirectIfOverLimit) {
      var raw = String(displayQty.value || '').trim().replace(',', '.');

      if (raw === '' || raw === '.' || raw === ',') {
        displayQty.value = mode === 'swatch' ? '1' : formatMeters(unitSize);
        update();
        return;
      }

      if (mode === 'meter') {
        var meters = normalizeUp(raw, unitSize, unitSize);

        displayQty.value = formatMeters(meters);

        if (redirectIfOverLimit && retailMeterLimit > 0 && meters > retailMeterLimit) {
          goWholesaleWithMeters(meters);
          return;
        }
      }

      update();
    }

    modeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        mode = button.dataset.hibaMode;

        modeButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });

        button.classList.add('is-active');

        if (mode === 'meter') {
          displayQty.value = formatMeters(unitSize);
        }

        if (mode === 'swatch') {
          displayQty.value = '1';
        }

        update();
      });
    });

    minus.addEventListener('click', function () {
      if (mode === 'wholesale') return;

      var current = parseFloat(String(displayQty.value || '').replace(',', '.'));
      var safeCurrent = Number.isFinite(current) ? current : mode === 'swatch' ? 1 : unitSize;

      if (mode === 'swatch') {
        displayQty.value = Math.max(1, safeCurrent - 1);
      } else {
        displayQty.value = formatMeters(Math.max(unitSize, safeCurrent - unitSize));
      }

      update();
    });

    plus.addEventListener('click', function () {
      if (mode === 'wholesale') return;

      var current = parseFloat(String(displayQty.value || '').replace(',', '.'));
      var safeCurrent = Number.isFinite(current) ? current : mode === 'swatch' ? 1 : unitSize;

      if (mode === 'swatch') {
        displayQty.value = Math.max(1, safeCurrent + 1);
      } else {
        displayQty.value = formatMeters(safeCurrent + unitSize);
      }

      update();
    });

    displayQty.addEventListener('input', previewWhileTyping);

    displayQty.addEventListener('change', function () {
      commitQtyInput(false);
    });

    displayQty.addEventListener('blur', function () {
      commitQtyInput(false);
    });

    displayQty.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        commitQtyInput(true);
      }

      if (event.key === 'Tab') {
        var raw = String(displayQty.value || '').trim().replace(',', '.');
        var meters = normalizeUp(raw, unitSize, unitSize);

        if (mode === 'meter' && retailMeterLimit > 0 && meters > retailMeterLimit) {
          event.preventDefault();
          commitQtyInput(true);
        }
      }
    });

    if (goWholesaleButton) {
      goWholesaleButton.addEventListener('click', function () {
        var meters = pendingWholesaleMeters || normalizeUp(displayQty.value, unitSize, unitSize);
        goWholesaleWithMeters(meters);
      });
    }

    if (wholesaleMeters) {
      wholesaleMeters.addEventListener('input', updateWholesale);
      wholesaleMeters.addEventListener('change', updateWholesale);
    }

    form.addEventListener('submit', function (event) {
      if (mode !== 'wholesale') {
        commitQtyInput(true);
      }

      if (mode === 'wholesale') {
        event.preventDefault();
        alert('Please submit a wholesale request instead of adding this to cart.');
      }
    });

    function wholesaleMessage() {
      var meters = wholesaleMeters ? wholesaleMeters.value || '' : '';

      return (
        'Hello, I would like a wholesale quote.\n\nProduct: ' +
        productTitle +
        '\nRequested quantity: ' +
        meters +
        ' meters\nProduct link: ' +
        productUrl
      );
    }

    if (wholesaleSubmit) {
      wholesaleSubmit.addEventListener('click', function () {
        var subject = encodeURIComponent('Wholesale quote request - ' + productTitle);
        var body = encodeURIComponent(wholesaleMessage());

        window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
      });
    }

    if (whatsapp) {
      whatsapp.addEventListener('click', function (event) {
        event.preventDefault();

        var cleanPhone = String(whatsappNumber).replace(/\D/g, '');
        var text = encodeURIComponent(wholesaleMessage());
        var whatsappUrl = 'https://wa.me/' + cleanPhone + '?text=' + text;

        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      });
    }

    if (!swatchVariantId && swatchButton) {
      swatchButton.disabled = true;
    }

    update();
  }

  function boot() {
    initAllHibaBuySelectors();

    window.setTimeout(initAllHibaBuySelectors, 250);
    window.setTimeout(initAllHibaBuySelectors, 700);
    window.setTimeout(initAllHibaBuySelectors, 1400);
    window.setTimeout(initAllHibaBuySelectors, 2500);
  }

  ready(boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  // HIBA: hide the Meter/Swatch/Wholesale selector when the selected variant is sold out / not sellable.
  function hibaSyncSoldOut() {
    document.querySelectorAll('[data-hiba-fabric-box]').forEach(function (box) {
      var form = box.closest('form[action*="/cart/add"]') ||
        (box.closest('.product__wrapper, .product-single, section, [data-section-id]') || document).querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var soldOut = false;
      form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]').forEach(function (b) {
        var t = (b.tagName.toLowerCase() === 'input' ? b.value : b.textContent) || '';
        var so = (window.HIBA_U5 && HIBA_U5.soldOut) || '';
        if (b.disabled || /sold\s*out|unavailable/i.test(t) || (so && t.indexOf(so) > -1)) soldOut = true;
      });
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.disabled) soldOut = true;
      if (soldOut) {
        box.hidden = true;
        box.style.display = 'none';
        box.setAttribute('data-hiba-sold-out', 'true');
      } else if (box.getAttribute('data-hiba-sold-out') === 'true') {
        box.hidden = false;
        box.style.display = '';
        box.removeAttribute('data-hiba-sold-out');
      }
    });
  }

  function hibaWatchSoldOut() {
    hibaSyncSoldOut();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__hibaSoldOutObs) return;
      form.__hibaSoldOutObs = new MutationObserver(function () { hibaSyncSoldOut(); });
      form.__hibaSoldOutObs.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value'] });
      form.addEventListener('change', function () { window.setTimeout(hibaSyncSoldOut, 50); });
    });
  }

  ready(function () { hibaWatchSoldOut(); window.setTimeout(hibaWatchSoldOut, 1500); window.setTimeout(hibaWatchSoldOut, 3000); });
  window.addEventListener('load', hibaWatchSoldOut);
  document.addEventListener('shopify:section:load', hibaWatchSoldOut);
  document.addEventListener('variant:change', function () { window.setTimeout(hibaSyncSoldOut, 50); });
})();
